module.exports = "/yunkezan/static/img/open-btn.png";